import ErrorBoundary from "components/ErrorBoundary";
import React, { useEffect, useRef, useState } from "react";
import { Card, Carousel, Col, Container, Row } from "reactstrap";
import Order from "../../assets/icon/order-entry1.svg";
import Initial from "../../assets/icon/initial-review-icon-14X14.svg";
import Pending from "assets/icon/pending-icon.svg";
import pack from "assets/icon/packaging-icon.svg";
import final from "assets/icon/final-review-icon.svg";
// import finalIcon from "assets/icon/final-icon.svg";
// import PatientsIcon from "assets/icon/patients.svg";
import OrderEntryHover from "../../assets/icon/order-entry-workflow.svg";
// import Inventory from "assets/icon/Inventory-icon-new.svg";
// import Claims from "assets/icon/claims.svg";
import InitialHover from "../../assets/icon/initial-review-hover.svg";
import PakagingIcon from "../../assets/icon/packaging-white-hover.svg";
import FinalIcon from "../../assets/icon/final-white-icon.svg";
// import reportsIcon from "assets/icon/reports-sideBar.svg";

// import PendingHover from "../../assets/icon/pending-gray.svg";
import PendingWhiteHover from "../../assets/icon/pending-white.svg";
import Drawer from "components/Drawer";
import UpcomingAppointments from "./UpcomingAppointments";
import InCompleteTask from "./InCompleteTask";
import { useNavigate } from "react-router-dom";

// import HoverImage from "react-hover-image/build";

const Dashboard = () => {
  const [activeTab, setActiveTab] = useState(1);
  const [upcoming, setUpcoming] = useState(false);
  const [incomp, setIncomp] = useState(false);
  const topRef = useRef();
  const navigatePath = useNavigate();

  const handleActiveTab = (id, navigate) => {
    setActiveTab(id);
    // window.location.href = navigate;
    navigatePath(navigate);
  };

  useEffect(() => {
    topRef.current.scrollIntoView(true);
  }, []);

  const cardData = [
    {
      id: 1,
      src: Order,
      srcHover: OrderEntryHover,
      title: "Order Entry",
      overDue: 4,
      total: 5,
      navigate: "/workflow-orderEntry",
    },
    {
      id: 2,
      src: Pending,
      srcHover: PendingWhiteHover,
      title: "Pending",
      overDue: 3,
      total: 6,
      navigate: "/workflow-pending",
    },
    {
      id: 3,
      src: Initial,
      srcHover: InitialHover,
      title: "Initial Review",
      overDue: 2,
      total: 5,
      navigate: "/workflow-initial",
    },
    {
      id: 4,
      src: pack,
      srcHover: PakagingIcon,
      title: "Packaging",
      overDue: 1,
      total: 5,
      navigate: "/workflow-packaging",
    },
    {
      id: 5,
      src: final,
      srcHover: FinalIcon,
      title: "Final Review",
      overDue: 2,
      total: 5,
      navigate: "/workflow-final",
    },
    // { id: 6, src: finalIcon, srcHover: reportsIcon, title: "Will Call", overDue: 3, total: 7 },
  ];

  const cardList2 = [
    {
      id: 114,
      title1: "Overdue",
      cardTexts: "11",
    },
    {
      id: 213,
      title1: "Appointments",
      cardTexts: "23",
    },
    {
      id: 313,
      title1: "Inventory Tasks",
      cardTexts: "06",
    },
    {
      id: 413,
      title1: "General Tasks",
      cardTexts: "14",
    },
    {
      id: 513,
      title1: "Phone Calls",
      cardTexts: "34",
    },
  ];
  const upcomingTask = [
    {
      id: 1234,
      task2: "Miller, John ",
      taskContentUp: "Immunization ",
      time: "09:00 AM",
      min: "30 Min left",
    },
    {
      id: 1334,
      task2: "Smith, Sally",
      taskContentUp: "Covid Test",
      time: "10:00 AM",
      min: "1 hr left",
    },
    {
      id: 1434,
      task2: "Eagan, Helena",
      taskContentUp: "Immunization ",
      time: "10:30 AM",
      min: "1.5 hrs Left",
    },
    {
      id: 1534,
      task2: "Scout, Mark",
      taskContentUp: "Flu Test ",
      time: "11:00 AM",
      min: "2 hrs Left",
    },
    {
      id: 1634,
      task2: "Garner, Doug",
      taskContentUp: "Immunization",
      time: "11:30 AM",
      min: "2.5 hrs Left",
    },
  ];
  const inCompleteTaskList = [
    {
      id: 12,
      task1: "Put away wholesaler Order",
      taskContent: "Recurring ",
    },
    {
      id: 13,
      task1: "Preventative Maintenance for ScriptPro",
      taskContent: "Recurring ",
    },
    {
      id: 14,
      task1: "Catch up on patient adherence calls",
      taskContent: "One-Time Only ",
    },
    {
      id: 15,
      task1: "Restock supplies",
      taskContent: "Recurring  ",
    },
    {
      id: 16,
      task1: "Complete HIPAA training module (all staff)",
      taskContent: "One-Time Only",
    },
  ];

  return (
    <div class="container-fluid bg-light mb-2" ref={topRef}>
      <div className="p-3 bg-white rounded">
        <h1 className="heading-text" style={{ marginBottom: "8px" }}>
          Overview
        </h1>
        <div
          style={{ border: "1px solid #D3D3D3", marginBottom: "16px" }}
        ></div>

        <div className="Card-list-parent rounded">
          {cardData.map((card) => (
            <div
              className={`card-body-top ${
                activeTab === card.id ? "active" : ""
              }`}
              key={card.id}
              onClick={() => handleActiveTab(card.id, card.navigate)}
              style={{
                cursor: "pointer",
                borderRadius: "8px",
                // border: activeTab === card.id ? "1px solid #702c62" : "1px solid #cbcbcb",
              }}
            >
              <div className="card-img">
                <img
                  src={activeTab === card.id ? card.srcHover : card.srcHover}
                  alt={`Order ${card.id}`}
                />
              </div>
              <div>
                <div className="card-titel">{card.title}</div>
                <div className="over-due">
                  <span>Overdue</span> {card.overDue}
                </div>
                <div className="total">
                  <span>Total</span> {card.total}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="br-height"></div>

      <div className="d-flex" style={{ gap: "8px" }}>
        <div
          className="bg-white border-radius-8 p-l-16 p-r-16 "
          style={{ width: "50%", border: "1px solid #D3D3D3" }}
        >
          <div className="p-t-16">
            {/* <h1 className="overview-text">Upcoming Appointments (76)</h1>
            <hr style={{ color: "#D3D3D3" }} /> */}
            <h1 className="heading-text" style={{ marginBottom: "8px" }}>
              Upcoming Appointments
            </h1>
            <div
              style={{ border: "1px solid #D3D3D3", marginBottom: "16px" }}
            ></div>
          </div>
          {upcomingTask.map((up) => (
            <div
              key={up.id}
              className="d-flex justify-content-between mb-2"
              style={{ marginTop: "2px" }}
            >
              <div>
                <h4 className="dash-name">{up.task2} </h4>
                <h5 className="dash-cont">{up.taskContentUp}</h5>
              </div>

              <div
                className="d-flex flex-column align-items-start"
                style={{ width: "5vw" }}
              >
                <h4 className="time">{up.time} </h4>
                <h5 className="min">{up.min}</h5>
              </div>
            </div>
          ))}

          <div className="d-flex justify-content-between ">
            <div>
              <h4
                className="link-drawar "
                style={{ cursor: "pointer" }}
                onClick={() => setUpcoming(true)}
              >
                +60 More{" "}
              </h4>
              {/* <h5 className="dash-cont">Immunization</h5> */}
            </div>

            {/* <div>
              <h4 className="time">11:30 AM </h4>
              <h5 className="min">2.5 hrs Left</h5>
            </div> */}
          </div>
        </div>

        <div
          className="bg-white border-radius-8 "
          style={{ width: "50%", border: "1px solid #D3D3D3" }}
        >
          <div className="p-l-16 p-r-16 p-t-16">
            {/* <h1 className="overview-text">Incomplete Tasks (23)</h1>
            <hr style={{ color: "#D3D3D3" }} /> */}
            <h1 className="heading-text" style={{ marginBottom: "8px" }}>
              Incomplete Tasks
            </h1>
            <div
              style={{ border: "1px solid #D3D3D3", marginBottom: "16px" }}
            ></div>
          </div>
          {inCompleteTaskList.map((t) => (
            <div key={t.id} className=" p-l-16 p-r-16 ">
              <div className="d-flex flex-column align-items-start mb-2">
                <h4 className="dash-name">{t.task1}</h4>
                <h5 className="min">{t.taskContent} </h5>
              </div>
            </div>
          ))}
          <div className="p-l-16 ">
            <h4
              className="link-drawar p-b-16 "
              style={{ cursor: "pointer" }}
              onClick={() => setIncomp(true)}
            >
              +20 More{" "}
            </h4>
          </div>
        </div>
      </div>

      <div className="br-height"></div>
      <div className="p-3 bg-white rounded">
        <h1 className="heading-text" style={{ marginBottom: "8px" }}>
          Next Hour
        </h1>
        <div
          style={{ border: "1px solid #D3D3D3", marginBottom: "16px" }}
        ></div>
        <Row>
          <div className="next-hour-box">
            {cardList2.map((data1) => (
              <div key={data1.id} className="custom-card">
                <div className="next-hour-title">{data1.title1}</div>
                <div className="next-hour-count">{data1.cardTexts}</div>
              </div>
            ))}
          </div>
        </Row>
      </div>
      <Drawer
        direction="end"
        size="lg"
        isOpen={upcoming}
        toggle={() => setUpcoming(!upcoming)}
        title="Upcoming Appointments List (76)"
      >
        <UpcomingAppointments />
      </Drawer>
      <Drawer
        direction="end"
        size="lg"
        isOpen={incomp}
        toggle={() => setIncomp(!incomp)}
        title="Incomplete Tasks (23)"
      >
        <InCompleteTask />
      </Drawer>
    </div>
  );
};

export default Dashboard;
